import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <footer className="footer-custom">
      <div className="container">
        <p className="m-1 text-white text-center text-md-end">
          © {new Date().getFullYear()} NORDCOM. All rights reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;
